import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScanTable from './pages/ScanTable';
import TableMenu from './pages/TableMenu';
import QRCart from './pages/QRCart';
import QRCheckout from './pages/QRCheckout';
import OrderConfirmation from './pages/OrderConfirmation';
import OrderTracking from './pages/OrderTracking';
import './QROrderApp.css';

const QROrderApp = () => {
  return (
    <div className="qr-order-app">
      <Routes>
        <Route path="/" element={<ScanTable />} />
        <Route path="/table/:tableId" element={<TableMenu />} />
        <Route path="/cart/:tableId" element={<QRCart />} />
        <Route path="/checkout/:tableId" element={<QRCheckout />} />
        <Route path="/confirmation/:orderId" element={<OrderConfirmation />} />
        <Route path="/track/:orderId" element={<OrderTracking />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

export default QROrderApp;
